import { appSync, isAnyOf, startListening } from '@betty/toolkit/state';
import {
  fetchShopItems,
  openShopRewardsBottomSheet,
  purchaseShopItem,
} from './items.slice';
import { ShopPurchaseErrorPayload } from './items.types';
import { BottomSheet } from '@betty/navigation';
import {
  defaultShopError,
  shopErrorContentMap,
} from '../../content/shop.content';
import { parseShopItemRewards } from '../../utils/shop.utils';

startListening({
  matcher: isAnyOf(appSync, purchaseShopItem.fulfilled),
  effect: (_, { dispatch }) => {
    dispatch(fetchShopItems());
  },
});

startListening({
  actionCreator: openShopRewardsBottomSheet,
  effect: (action) => {
    const payload = action.payload;

    BottomSheet.open({
      namespace: 'rewards',
      type: 'RewardReceivedBottomSheet',
      presentAnimation: 'confetti',
      singleton: false,
      light: true,
      data: {
        rewards: parseShopItemRewards(payload),
      },
      scrollable: true,
      enableContentPanningGesture: false,
    });
  },
});

startListening({
  actionCreator: purchaseShopItem.rejected,
  effect: (action) => {
    const payload = action.payload as ShopPurchaseErrorPayload;

    const errorCode = payload?.data.errorCode;

    const shopError =
      (errorCode && shopErrorContentMap[errorCode]) ?? defaultShopError;

    BottomSheet.open({
      namespace: 'common',
      type: 'Info',
      titleNS: 'shop',
      titleKey: 'shopErrorTitleSorry',
      data: {
        textNS: shopError.locNS,
        textKey: shopError.locKey,
      },
    });
  },
});
